import axiosPost from '../axiosPost';

export const tiposDeDeviceIns = async (arg) => {
    const { nombre, codigo } = arg;

    const body = {
        "service": "TipoDeviceIns",
        "params": {
            "tipoDeviceNombre": nombre,
            "tipoDeviceCod": codigo
        }
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}